import { useEffect, useRef, useState } from 'react'

export function useDebouncedValue<T>(value: T, delay = 500): T {
  const [debouncedValue, setDebouncedValue] = useState(value)
  // Initialized on first effect run rather than during render — calling Date.now()
  // in render is impure and produces unstable results across re-renders.
  const lastUpdateTime = useRef<number | null>(null)

  useEffect(() => {
    const now = Date.now()
    const timeSinceLastUpdate = now - (lastUpdateTime.current ?? now)
    const timeRemaining = delay - timeSinceLastUpdate

    const timer = setTimeout(
      () => {
        setDebouncedValue(value)
        lastUpdateTime.current = Date.now()
      },
      Math.max(timeRemaining, 0) // do it now if we're already past the delay, otherwise wait the remaining time
    )

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])

  return debouncedValue
}
